import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { trackEcommerce, trackEvent } from 'dibs-tracking';
import { getCategories } from '../../utils/categoryHelpers';
import { createFragmentContainer, graphql } from 'react-relay';

class SbSharedCategoryTilesTrackingComponent extends React.Component {
    constructor() {
        super();

        this.fireTracking = this.fireTracking.bind(this);
        this.trackClick = this.trackClick.bind(this);
    }

    componentDidMount() {
        this.fireTracking();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchBrowse.displayUriRef !== this.props.searchBrowse.displayUriRef) {
            this.fireTracking();
        }
    }

    fireTracking() {
        const { searchBrowse, pageLevel } = this.props;

        if (searchBrowse.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles displayed',
                label: `l${pageLevel}`,
            });
        } else {
            trackEcommerce({
                type: 'promotionImpression',
                promotions: this.getTrendingPromotions(),
            });
        }
    }

    trackClick(index) {
        const { pageLevel, searchBrowse } = this.props;

        if (searchBrowse.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles clicked',
                label: `l${pageLevel}`,
            });
        } else {
            const promotions = this.getTrendingPromotions();
            trackEcommerce({
                type: 'promoClick',
                promotions: [promotions[index]],
            });
        }
    }

    getTrendingPromotions() {
        const { searchBrowse, pageLevel, maxTilesAllowed } = this.props;
        const { categoryTiles } = searchBrowse;

        let tiles = categoryTiles || [];
        tiles = maxTilesAllowed ? categoryTiles.slice(0, maxTilesAllowed) : categoryTiles;

        return tiles.map((tile, i) => ({
            creative: tile.displayName,
            id: `L${pageLevel + 1}-result-tiles`,
            name: `L${pageLevel}|Result Tiles`,
            position: i + 1,
            itemId: tile.itemId,
        }));
    }

    render() {
        const { trackClick } = this;
        return this.props.children({ trackClick });
    }
}

SbSharedCategoryTilesTrackingComponent.propTypes = {
    pageLevel: PropTypes.number,
    maxTilesAllowed: PropTypes.number,
    children: PropTypes.func.isRequired,
    searchBrowse: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const appliedFilters = state.filters.appliedFilters;
    const categories = getCategories(appliedFilters);

    return {
        pageLevel: categories.length,
    };
}

export const SbSharedCategoryTilesTracking = createFragmentContainer(
    connect(mapStateToProps)(SbSharedCategoryTilesTrackingComponent),
    {
        searchBrowse: graphql`
            fragment SbSharedCategoryTilesTracking_searchBrowse on SearchBrowseQueryConnection {
                displayUriRef
                pageType
                categoryTiles {
                    displayName
                    itemId
                }
            }
        `,
    }
);
